const FINE_DASHED_BORDER_DEFAULT_COLOR = '#999999';
const FINE_DASHED_BORDER_HOVER_COLOR = '#0EA5E9';

export const getFineDashedBorderBackground = (hovered: boolean): string => {
    const stroke = encodeURIComponent(hovered ? FINE_DASHED_BORDER_HOVER_COLOR : FINE_DASHED_BORDER_DEFAULT_COLOR);

    return `url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='100%25' height='100%25'%3e%3crect width='100%25' height='100%25' fill='none' rx='6' ry='6' stroke='${stroke}' stroke-width='1' stroke-dasharray='2%2c2'/%3e%3c/svg%3e")`;
};
